var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 0H224C188.654 0 160 28.652 160 64V288C160 323.346 188.654 352 224 352H448C483.348 352 512 323.346 512 288V64C512 28.652 483.348 0 448 0ZM464 288C464 296.822 456.822 304 448 304H224C215.178 304 208 296.822 208 288V64C208 55.178 215.178 48 224 48H448C456.822 48 464 55.178 464 64V288ZM304 448C304 456.822 296.822 464 288 464H64C55.178 464 48 456.822 48 448V224C48 215.178 55.178 208 64 208H128V160H64C28.654 160 0 188.652 0 224V448C0 483.346 28.654 512 64 512H288C323.348 512 352 483.346 352 448V384H304V448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.2f47328ab2a110d177250eb43005d354.svg";
export { ForwardRef as ReactComponent };